// extracted by css-extract-rspack-plugin
export default {"SnippetForm":"SnippetForm-module__SnippetForm___EYBb4","FormSnippetTextArea":"SnippetForm-module__FormSnippetTextArea___FgWOT"};